import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { CustomNavigationClient } from "./NavigationClient";

import { ErrorProvider } from "./context/ErrorContext";

import ProjectProvider, {        // ← ahora sí existe el default
  PdfHighlightProvider,
} from "./context/ProjectProvider";

import ApplicationPage from "./components/Pages/ApplicationPage";
import Profile          from "./components/Auth/Profile";
import Payment          from "./components/Pages/Payment";

/* ────────────────────────────────────────────────────────────── */
/*  Creamos el navigation-client **dentro** del efecto para que  */
/*  no cambie en cada render y desaparezca la advertencia ESLint */
function ClientSideNavigation({ pca, children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);
  }, [pca, navigate]);      // ← deps mínimos

  return children;
}

function App({ pca }) {
  return (
    <ClientSideNavigation pca={pca}>
      <ErrorProvider>
        <PdfHighlightProvider>
          <ProjectProvider>
            <Routes>
              <Route path="/"        element={<ApplicationPage />} />
              <Route path="/profile" element={<Profile />}         />
              <Route path="/payment" element={<Payment />}         />
            </Routes>
          </ProjectProvider>
        </PdfHighlightProvider>
      </ErrorProvider>
    </ClientSideNavigation>
  );
}


/* ────────────────────────────────────────────────────────────── */
export default function RootApp({ pca }) {
  return (
    <Router>
      <App pca={pca} />
    </Router>
  );
}
